import { __decorate } from "tslib";
import { Vue, Component } from "vue-property-decorator";
let LoadingSpinner = class LoadingSpinner extends Vue {
};
LoadingSpinner = __decorate([
    Component({})
], LoadingSpinner);
export default LoadingSpinner;
